import React from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import PopulationOverview from '../components/analysis/PopulationOverview';
import BatchExplorer from '../components/analysis/BatchExplorer';
import SubgroupAnalysis from '../components/analysis/SubgroupAnalysis';
import IndividualExplorer from '../components/analysis/IndividualExplorer';
import HistoryExplorer from '../components/analysis/HistoryExplorer';

const AnalysisDashboard: React.FC = () => {
  return (
    <Container fluid className="mt-4">
      <h1 className="mb-4">Tableau de bord — Données inflammatoires</h1>
      <Tabs defaultActiveKey="population" id="analysis-dashboard-tabs" className="mb-3" mountOnEnter={true} unmountOnExit={true}>
        <Tab eventKey="population" title="Vue d’ensemble (population)">
          <PopulationOverview />
        </Tab>
        <Tab eventKey="batch" title="Explorateur de lots">
          <BatchExplorer />
        </Tab>
        <Tab eventKey="subgroup" title="Analyse par sous-groupes">
          <SubgroupAnalysis />
        </Tab>
        <Tab eventKey="individual" title="Explorateur individuel">
          <IndividualExplorer />
        </Tab>
        <Tab eventKey="history" title="Historique et évolution">
          <HistoryExplorer />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default AnalysisDashboard;